import React, { Component } from "react";
class MotivationalQuotePreview extends Component {

    render() {

        const { quotesData, animationStyle, animationStyleNew, onUpdateFontSize } = this.props;
        return quotesData && Object.keys(quotesData).length > 0 && <div className={`mqtd_quote_card mqtd_quote_card_new ${animationStyleNew}`} style={{ backgroundImage: `url(${quotesData.background})` }}  >
            <div className="mqtd_quote_overlay"></div>
            <div className={`mqtd_quoteCardContent flexStyle ${animationStyle}`}>
                <div className={`overlay2 ${animationStyle}`}>
                    <div className={`mqtd_quote_icon ${animationStyle}`}><svg xmlns="http://www.w3.org/2000/svg" className="mqtd_quote_svg_icon" viewBox="0 0 103.366 82.649">
                        <path id="Path_2" data-name="Path 2" d="M-425.49-235.981h44.52v-44.3h-25.346c.661-7.934,2.2-11.461,6.171-14.767,4.408-3.747,8.816-5.51,17.411-6.832l-9.7-16.75c-10.579,2.424-15.648,4.849-21.379,10.359-7.714,6.832-11.681,16.53-11.681,27.991Zm59.066,0h44.3v-44.3h-25.125c.661-7.934,1.984-11.461,6.171-14.767,4.188-3.747,8.6-5.51,17.191-6.832l-9.7-16.75c-10.359,2.424-15.428,4.849-21.379,10.359-7.493,6.832-11.461,16.53-11.461,27.991Z" transform="translate(425.49 318.63)" fill="#dac30c" />
                    </svg>
                    </div>
                    <div className={`mqtd_quote_text resize  ${animationStyle}`} onLoad={onUpdateFontSize()}> {quotesData.description}</div>
                    <div className={`mqtd_quote_authername ${animationStyle}`}>- {quotesData.author}</div>
                </div>

            </div>
        </div>

    }
}

export default MotivationalQuotePreview

